import { render, staticRenderFns } from "./home-access.vue?vue&type=template&id=aec85824&scoped=true"
var script = {}
import style0 from "./home-access.vue?vue&type=style&index=0&id=aec85824&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aec85824",
  null
  
)

export default component.exports